import { t } from 'i18next';
import moment from 'moment';


const WeekFormatter = (date, isSpecialCase, weekRange, selectedWeek) => {

    const selectedDay = moment(date);
    const start = weekRange[0];
    const end = weekRange[1];

    const weekStart = start.date();
    const weekEnd = end.date();

    const monthStart = start.month();
    const monthEnd = end.month();

    const formattedStartMonthStr = t(`months.${monthStart}`).charAt(0).toUpperCase() + t(`months.${monthStart}`).slice(1);
    const formattedEndMonthStr = t(`months.${monthEnd}`).charAt(0).toUpperCase() + t(`months.${monthEnd}`).slice(1);

    const currentYear = selectedDay.year();

    const formattedMonthStr = isSpecialCase ? ((selectedWeek === 0) ? formattedStartMonthStr : formattedEndMonthStr) : '';
    return (
        <div>
            <span>
                {`${weekStart} ${formattedStartMonthStr.slice(0, 3)}-${weekEnd} ${formattedEndMonthStr.slice(0, 3)}`}
            </span>
            <span style={{
                marginLeft: '20px'
            }}>
                {` ${formattedMonthStr}  ${currentYear}`}
            </span>
        </div>
    );
}



export default WeekFormatter;